import React, { FC } from 'react'

export const ProfileGiftGreeting: FC<{
  isAuthorHidden: boolean
  greeting: string
}> = ({ isAuthorHidden, greeting }) => {
  if (!isAuthorHidden) {
    return <>{greeting}</>
  }

  return null
}
